import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "../../components/CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Box, Chip, DialogContentText, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConfirmationDialog from "../ConfirmationDialog";
import { setEventcustomisation } from "../../redux/slices/eventcustomisationsSlice";
import { setDmz } from "../../redux/slices/dmzSlice";
import MediaViewerDialog from "./MediaViewerDialog";
import { seteventcustomisationglobalupdate } from "../../redux/slices/eventCustomisationGlobalUpdateSlice";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import TableStatus from "../TableStatus";

const DmzTable = ({ selectedOption, errors, isLoading }) => {
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const dmzRecords = useSelector((state) => state.dmz.dmz);
  const checker = useSelector((state) => state.user.user.email); 
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectItemId, setRejectItemId] = useState(null);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] =
    React.useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const loggedInUser = useSelector((state) => state?.user?.user);
  const [currentMaker, setCurrentMaker] = useState("");
  const [currentChecker, setCurrentChecker] = useState("");
  const [currentAIComments, setCurrentAIComments] = useState("");
  const [currentCheckerComments, setCurrentCheckerComments] = useState("");
  const resolutions = useSelector((state) => state?.resolution?.resolutions);

  const handleViewImages = (row) => {
    setCurrentImages(row?.customisations?.map((c) => c.imageUrl) || []);
    setCurrentMaker(row?.maker || "");
    setCurrentChecker(row?.checker || "");
    setCurrentAIComments(row?.aiComments || "");
    setCurrentCheckerComments(row?.checkerComments || "");
    setCurrentImageIndex(0);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => setOpenViewModal(false);
  const handlePreviousImage = () =>
    setCurrentImageIndex((prev) => Math.max(prev - 1, 0));
  const handleNextImage = () =>
    setCurrentImageIndex((prev) =>
      Math.min(prev + 1, currentImages.length - 1)
    );

  const handleOpenRejectDialog = (customisationId) => {
    setRejectItemId(customisationId);
    setOpenRejectDialog(true);
  };

  const handleCloseRejectDialog = () => {
    setOpenRejectDialog(false);
    setRejectionReason("");
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCustomisationId, setSelectedCustomisationId] = useState(null);
  const handleApproveClick = (customisationId, status) => {
    if (status === "AI_REJECTED") {
      setSelectedCustomisationId(customisationId);
      setOpenDialog(true);
    } else {
      handleStatusUpdate(customisationId, "APPROVED");
    }
  };

  const handleConfirmApprove = () => {
    handleStatusUpdate(selectedCustomisationId, "APPROVED");
    setOpenDialog(false);
  };
  const handleCancel = () => {
    setOpenDialog(false);
  };
  const handleReject = () => {
    if (!rejectionReason.trim()) {
      alert("Please provide a reason for rejection.");
      return;
    }
    handleStatusUpdate(rejectItemId, "REJECTED", rejectionReason);
    handleCloseRejectDialog();
  };

  React.useEffect(() => {
    if (dmzRecords) setRows(dmzRecords);
  }, [dmzRecords]);

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);

    const requestBody = {
      path: "dmz",
      query: { customisationId: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setRows((prevRows) => {
         
          const updatedRows = prevRows?.filter(
            (row) => row.id !== response.data.id
          );

         
          dispatch(setEventcustomisation(updatedRows));

          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  const handleStatusUpdate = (
    customisationId,
    newStatus,
    userComments = ""
  ) => {
    const body = {
      customisationId: customisationId,
      checker: checker,
      status: newStatus,
      userComments,
    };

    const requestBody = {
      path: "dmz/status",
      query: {},
      emmsId: selectedOption,
      body: { ...body },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(`${api}/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === customisationId ? { ...row, status: newStatus } : row
          )
        );
        dispatch(seteventcustomisationglobalupdate(true));
        toast.success("Status changed successfully.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((error) => {
        console.error(`${newStatus} Error:`, error);
        toast.error("Error updating status.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  const columns = [
    {
      field: "image",
      headerName: "Image",
      sortable: false,
      flex: 2,
      minWidth: 200,
      renderCell: (params) => {
        const imageUrl = params?.row?.customisations?.[0]?.imageUrl || null;
        const isVideo = imageUrl ? /\.(mp4|avi|mov)$/i.test(imageUrl) : false;

        return imageUrl ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isVideo ? (
              <video
                controls
                style={{
                  width: "150px",
                  height: "105px",
                  borderRadius: "10px",
                }}
              >
                <source src={imageUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={imageUrl}
                alt="Customisation"
                style={{
                  width: "150px",
                  height: "105px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            )}
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>No Media</div>
        );
      },
    },

    { field: "eventCustomisationName", headerName: "Name", flex: 1, minWidth: 130 },

    {
      field: "status",
      headerName: "Status",
      flex: 1.4,
      minWidth: 140,
      renderCell: (params) => {
        const rawStatus = params?.value;

        const formatStatus = (status) => {
          return status.split("_").join(" ");
        };

        const getColor = (status) => {
          if (status.includes("APPROVED")) return "success";
          if (status.includes("REJECTED")) return "error";
          return "default";
        };

        return (
          <Chip
            label={formatStatus(rawStatus)}
            color={getColor(rawStatus)}
            variant="contained"
          />
        );
      },
    },
    {
      field: "suitable",
      headerName: "Suitable Screens",
      flex: 1.4,
      minWidth: 160,
      renderCell: (params) => {
        const matchingResolutions =
          params?.row?.customProperties?.matchingResolutions || [];

        const resolutionNames = matchingResolutions.map((resolutionValue) => {
          const resolution = resolutions?.find(
            (r) => r.value === resolutionValue
          );

          return resolution?.name || resolutionValue;
        });

        return (
          <Stack
            direction="column"
            spacing={0.5}
            alignItems="center"
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
            }}
          >
            {resolutionNames.length > 0 ? (
              resolutionNames.map((resolutionName, index) => (
                <Chip
                  key={index}
                  label={resolutionName}
                  size="small"
                  color="success"
                  variant="filled"
                  sx={{ fontSize: "0.75rem" }}
                />
              ))
            ) : (
              <Chip
                label="No matching resolutions"
                size="small"
                color="warning"
                variant="filled"
                sx={{ fontSize: "0.75rem" }}
              />
            )}
          </Stack>
        );
      },
    },

    {
      field: "view",
      headerName: "View",
      flex: 1.2,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          startIcon={<VisibilityIcon />}
          onClick={() => handleViewImages(params?.row)}
        >
          View
        </Button>
      ),
    },
    ,
    {
      field: "approve",
      headerName: "Approve",
      flex: 1.2,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            handleApproveClick(
              params?.row?.meetingCustomisationId,
              params?.row?.status
            )
          }
          disabled={
            params?.row?.status === "APPROVED" ||
            params.row.maker === loggedInUser.email ||
            (loggedInUser?.customProperties?.checker === true ||
             loggedInUser?.customProperties?.checker === "true") === false
          }
        >
          {params?.row?.status === "APPROVED" ? "Approved" : "Approve"}
        </Button>
      ),
    },

    ,
    {
      field: "reject",
      headerName: "Reject",
      flex: 1.1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          onClick={() =>
            handleOpenRejectDialog(params?.row?.meetingCustomisationId)
          }
          disabled={
            params?.row?.status === "REJECTED" ||
            params?.row?.status === "APPROVED" ||
            params.row.maker === loggedInUser.email ||
            loggedInUser?.customProperties?.checker === false ||
            loggedInUser?.customProperties?.checker === "false"
          }
        >
          {params?.row?.status === "REJECTED" ? "Rejected" : "Reject"}
        </Button>
      ),
    },

    {
      field: "delete",
      headerName: "Delete",
      flex: 1.3,
      minWidth: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params?.row?.meetingCustomisationId)}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  return (
    <>
      {rows?.length > 0 && !errors ? (
        <Box className="emms-data-grid-container" sx={{ padding: "2.5% 10%", overflowX: "auto" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: { paginationModel: { pageSize: 5 } },
              filter: {
                filterModel: {
                  items: [
                    {
                      field: "status",
                      operator: "doesNotEqual",
                      value: "APPROVED",
                    },
                  ],
                },
              },
              sorting: {
                sortModel: [{ field: "updatedAt", sort: "desc" }],
              },
            }}
            pageSizeOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
            slots={{ toolbar: GridToolbar }}
            slotProps={{ toolbar: { showQuickFilter: true } }}
            rowHeight={120}
          />
        </Box>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
      {showConfirmationDialog && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      )}
      <Dialog open={openDialog} onClose={handleCancel}>
        <DialogTitle>Warning</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Warning: This content has been rejected by TruRooms AI due to
            non-compliance with our guidelines. Do you want to approve it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            Reject
          </Button>
          <Button onClick={handleConfirmApprove} color="primary" autoFocus>
            Approve
          </Button>
        </DialogActions>
      </Dialog>
      ;
      <MediaViewerDialog
        open={openViewModal}
        onClose={handleCloseViewModal}
        currentImages={currentImages}
        currentImageIndex={currentImageIndex}
        handlePreviousImage={handlePreviousImage}
        handleNextImage={handleNextImage}
        maker={currentMaker}
        checker={currentChecker}
        aiComments={currentAIComments}
        checkerComments={currentCheckerComments}
      />
      <Dialog open={openRejectDialog} onClose={handleCloseRejectDialog}>
        <DialogTitle>Provide Rejection Reason</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for rejection"
            type="text"
            fullWidth
            multiline
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleReject} variant="outlined" color="error">
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DmzTable;
